import {
  PopoverDisclosure,
  Popover,
  usePopoverState,
  VisuallyHidden,
  PopoverInitialState,
} from 'reakit';
import { ReactNode } from 'react';
import { MiniClose, MiniQuestion } from '@mos-cat/ds-icons';
import { UtilityButton } from '../UtilityButton/UtilityButton';
import { Box } from '../Box/Box';
import { StylesOptions } from '../hooks/useStyles';
import { useRequiredPropWarning } from '../hooks/useRequiredPropWarning';

/**
 * @deprecated - Используйте компонент Popover
 */
export type InfoPopoverProps = {
  /**
   * Невидимый текст на кнопке
   */
  label: string;
  /**
   * Содержимое поповера
   */
  children: ReactNode;
  /**
   * Изначальная позиция поповера
   * В настоящий момент переопределить после создания компонента невозможно
   */
  initialPlacement?: PopoverInitialState['placement'];
  /**
   * Флаг убирает отступы, если содержимое поповера - изображение
   */
  image?: boolean;
} & StylesOptions;

/**
 * @deprecated - Используйте компонент Popover
 */
export function InfoPopover({
  label,
  children,
  initialPlacement,
  image,
  styles,
}: InfoPopoverProps) {
  const popover = usePopoverState({
    placement: initialPlacement || 'top',
    gutter: 10,
  });
  useRequiredPropWarning(Boolean(label), 'InfoPopover', 'label');
  useRequiredPropWarning(Boolean(children), 'InfoPopover', 'children');
  return (
    <>
      <PopoverDisclosure {...popover} as={UtilityButton}>
        <Box
          borderRadius="round"
          border={2}
          borderColor={popover.visible ? 'blue-20' : 'gray-20'}
          bg={popover.visible ? 'blue-10' : 'white'}
          width={20}
          height={20}
          display="flex"
          alignItems="center"
          pointerEvents="none"
          aria-hidden
          as={popover.visible ? MiniClose : MiniQuestion}
        >
          <VisuallyHidden>{label}</VisuallyHidden>
        </Box>
      </PopoverDisclosure>
      <Popover
        {...popover}
        as={Box}
        styles={styles}
        zIndex={2}
        bg="blue-10"
        borderRadius={4}
        border={2}
        borderColor="blue-20"
        boxShadow="0 3px 4px 0 rgba(14,14,15,0.1)"
        px={image ? 'sp-0' : 'sp-16'}
        py={image ? 'sp-0' : 'sp-16'}
        width={283}
      >
        {children}
      </Popover>
    </>
  );
}
